function UserRowRenderer()
{
    this.constructor = UserRowRenderer;
}

UserRowRenderer.prototype.init = function ()
{
    return this;
};

UserRowRenderer.prototype.getRowClasses = function ( userListUserInfo )
{
    var classes = ["userListRow"];
    if( !userListUserInfo.enabled )
        classes.push( "disabled" );
    if( userListUserInfo.enabledInOtherProduct !== null )
    {
        classes.push( "linkedNotNull" );
        if( userListUserInfo.enabledInOtherProduct === true )
            classes.push( "linkedWithActiplans" );
    }
    if( userListUserInfo.hasManageUsersRight )
        classes.push( "accountPermission" );
    if( userListUserInfo.hasManageSettingsRight )
        classes.push( "settingsPermission" );
    if( userListUserInfo.hasManageCustomersProjectsRight )
        classes.push( "customerProjectPermission" );
    if( userListUserInfo.hasManageTasksRight )
        classes.push( "taskPermission" );
    if( userListUserInfo.locked )
        classes.push( "locked" );
    return classes;
};

UserRowRenderer.prototype.updateUI = function ( row, userListUserInfo )
{
    row.getRowEl().className = this.getRowClasses( userListUserInfo ).join( " " );
};

export default UserRowRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/UserRowRenderer.js